@if (appState().isInitialized) {
  <div class="flex flex-col h-full" style="padding-bottom: 50px">
    <div class="z-10 bg-white">
      <app-header />
    </div>

    <div class="flex-1 min-h-0">
      <router-outlet />
    </div>

    <div class="absolute bottom-0 left-0 w-full">
      <app-footer />
    </div>
  </div>
} @else {
  <div class="content-center p-7">
    <app-loading-indicator />
  </div>
}
